/* ==========================================================================
   Dynoforce zoekbalk met auto's

   De zoekbalk toonde alleen producten, en Shopify matcht op elk woord apart:
   "bmw m4 g82" gaf duizend losse delen en nooit de auto zelf. Dit script
   herkent in de zoekterm een auto (merk, modelnaam, chassiscode, bouwjaar),
   een onderdeel (bodykit, splitter, skirts, ...) of een kenteken, en zet dat
   als eerste blok in het uitklapmenu en bovenaan de resultatenpagina.

   De autolijst is dezelfde als die van de autokiezer in de menubalk
   ([data-dfa-autos], 160 regels met merk, modelgroep, label en url), dus er
   komt geen opvraging bij. Herkenning werkt zoals de zoekbalk op /collections:
   op woordbegin, met samentrekkingen ("rs 3" en "rs3"), en als terugval op
   de aaneengeschreven tekst ("x5m").

   Gebruikt vanuit assets/df-header.js (blok, ververs, tussenkop) en op de
   resultatenpagina (sections/df-zoekresultaten.liquid, [data-df-zr-auto]).
   ========================================================================== */
(function () {
  'use strict';
  if (window.DFZoekAuto) return;

  var EN = String(document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var T = EN ? {
    jouwAuto: 'Your car', producten: 'Products', kenteken: 'Licence plate',
    zoekKt: 'Look up plate ', ktSub: 'We check which car it is and show what fits',
    alles: 'Everything that fits', voorAuto: ' for your car', alleenPassend: 'Only the parts that fit',
    meer: ' more, choose your car', merkAlle: 'All ', merkDelen: ' parts',
    merkSub: 'Add your model or chassis code, for example m4 or g82',
    zrAuto: 'Your car', zrKop: 'Parts for ', zrHint: 'Click your car and you only see what fits.',
    zrKt: 'Look up plate '
  } : {
    jouwAuto: 'Jouw auto', producten: 'Producten', kenteken: 'Kenteken',
    zoekKt: 'Zoek op kenteken ', ktSub: 'We kijken welke auto het is en laten zien wat erop past',
    alles: 'Alles wat past', voorAuto: ' voor jouw auto', alleenPassend: 'Alleen de delen die passen',
    meer: ' andere, kies je auto', merkAlle: 'Alle ', merkDelen: ' onderdelen',
    merkSub: 'Typ je model of chassiscode erbij, bijvoorbeeld m4 of g82',
    zrAuto: 'Jouw auto', zrKop: 'Onderdelen voor ', zrHint: 'Klik je auto aan, dan zie je alleen wat past.',
    zrKt: 'Zoek op kenteken '
  };

  function plat(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').replace(/\s+/g, ' ').trim(); }

  var ONDERDELEN = [
    { woorden: ['bodykit', 'bodykits', 'body kit', 'widebody', 'wide body', 'kit'], label: 'Bodykits', en: 'Body kits', types: ['Widebody Kit', 'Bodykit Set', 'Bodykit onderdeel'] },
    { woorden: ['splitter', 'splitters', 'front splitter', 'frontsplitter', 'lip', 'voorlip', 'frontlip', 'front lip'], label: 'Front splitters', en: 'Front splitters', types: ['Front Splitter'] },
    { woorden: ['skirts', 'skirt', 'side skirts', 'sideskirts', 'sideskirt', 'dorpels'], label: 'Side skirts', en: 'Side skirts', types: ['Side Skirts'] },
    { woorden: ['diffuser', 'diffusers', 'diffusor'], label: 'Diffusers', en: 'Diffusers', types: ['Diffuser'] },
    { woorden: ['spoiler', 'spoilers', 'vleugel', 'achtervleugel', 'wing', 'dakspoiler', 'kofferdekselspoiler', 'ducktail'], label: 'Spoilers', en: 'Spoilers', types: ['Spoiler', 'Achtervleugel'] },
    { woorden: ['motorkap', 'motorkappen', 'bonnet', 'hood'], label: 'Motorkappen', en: 'Hoods', types: ['Motorkap'] },
    { woorden: ['spiegelkappen', 'spiegelkap', 'spiegels', 'mirror', 'mirrors'], label: 'Spiegelkappen', en: 'Mirror caps', types: ['Spiegelkappen'] },
    { woorden: ['grille', 'grilles', 'nieren', 'niergrille', 'grill'], label: 'Grilles', en: 'Grilles', types: ['Grille'] },
    { woorden: ['intake', 'intakes', 'inlaat', 'luchtinlaat', 'airbox', 'eventuri'], label: 'Intakes', en: 'Intakes', types: ['Carbon Intake'] },
    { woorden: ['canards', 'canard'], label: 'Canards', en: 'Canards', types: ['Canards'] },
    { woorden: ['vents', 'vent', 'luchtuitlaten'], label: 'Vents', en: 'Vents', types: ['Vents'] },
    { woorden: ['interieur', 'interior'], label: 'Interieur', en: 'Interior', types: ['Interieur'] },
    { woorden: ['spatborden', 'spatbord', 'fenders'], label: 'Spatborden', en: 'Fenders', types: ['Spatborden'] }
  ];
  var MERK_ALIAS = { vw: 'volkswagen', mercedes: 'mercedes benz', merc: 'mercedes benz', amg: 'mercedes benz' };

  function bereid(autos) {
    return autos.map(function (r) {
      var tekst = plat(r.m + ' ' + r.g + ' ' + r.l);
      return { m: r.m, g: r.g, l: r.l, u: r.u, p: ' ' + tekst + ' ', aan: tekst.replace(/ /g, ''), codes: plat(r.l.split('(')[0]).split(' ') };
    });
  }

  /* Alle manieren om buurtokens aan elkaar te plakken, meest geplakt eerst:
     ["rs","3"] -> ["rs3"] en ["rs","3"]. */
  function lezingen(delen) {
    if (delen.length <= 1) return [delen];
    var uit = [];
    var rest = lezingen(delen.slice(1));
    rest.forEach(function (r) { uit.push([delen[0] + r[0]].concat(r.slice(1))); });
    rest.forEach(function (r) { uit.push([delen[0]].concat(r)); });
    return uit;
  }

  function haalOnderdeel(delen) {
    var tekst = ' ' + delen.join(' ') + ' ';
    var beste = null;
    ONDERDELEN.forEach(function (o) {
      o.woorden.forEach(function (w) {
        var i = tekst.indexOf(' ' + w + ' ');
        if (i !== -1 && (!beste || w.length > beste.w.length)) beste = { o: o, w: w };
      });
    });
    if (!beste) return { onderdeel: null, rest: delen };
    var rest = plat(tekst.replace(' ' + beste.w + ' ', ' ')).split(' ').filter(Boolean);
    return { onderdeel: beste.o, rest: rest };
  }

  /* Een Nederlands kenteken: zes tekens in een van de sidecodes, en zonder
     spaties getypt. "a45 amg" is een auto, "RJ-066-B" en "rj066b" een plaat. */
  var SIDECODES = [/^[A-Z]{2}\d{4}$/, /^\d{2}[A-Z]{2}\d{2}$/, /^\d{4}[A-Z]{2}$/, /^[A-Z]{2}\d{2}[A-Z]{2}$/, /^[A-Z]{4}\d{2}$/, /^\d{2}[A-Z]{4}$/, /^\d{2}[A-Z]{3}\d$/, /^\d[A-Z]{3}\d{2}$/, /^[A-Z]{2}\d{3}[A-Z]$/, /^[A-Z]\d{3}[A-Z]{2}$/, /^[A-Z]{3}\d{2}[A-Z]$/, /^[A-Z]\d{2}[A-Z]{3}$/, /^\d[A-Z]{2}\d{3}$/, /^\d{3}[A-Z]{2}\d$/];
  function isKenteken(q) {
    if (/\s/.test(q.trim())) return null;
    var k = q.toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (k.length !== 6) return null;
    for (var i = 0; i < SIDECODES.length; i++) if (SIDECODES[i].test(k)) return k;
    return null;
  }
  function kentekenNet(k) {
    var m = k.match(/^([A-Z]+|\d+)([A-Z]+|\d+)([A-Z]+|\d+)$/);
    if (m) return m[1] + '-' + m[2] + '-' + m[3];
    return k.slice(0, 2) + '-' + k.slice(2, 4) + '-' + k.slice(4);
  }

  function zoekAutos(lijst, delen) {
    if (!delen.length) return [];
    var woorden = delen.map(function (d) { return MERK_ALIAS[d] || d; });
    var lez = lezingen(woorden.join(' ').split(' '));
    for (var i = 0; i < lez.length; i++) {
      var treffers = lijst.filter(function (r) {
        for (var j = 0; j < lez[i].length; j++) if (r.p.indexOf(' ' + lez[i][j]) === -1) return false;
        return true;
      });
      if (treffers.length) return rangschik(treffers, lez[i]);
    }
    var aanEen = woorden.join('');
    if (aanEen.length >= 3) return rangschik(lijst.filter(function (r) { return r.aan.indexOf(aanEen) !== -1; }), [aanEen]);
    return [];
  }

  /* Een chassiscode die precies in het label staat wint van een losse treffer
     op de modelgroep; nieuwer eerst binnen gelijke score. */
  function rangschik(treffers, tokens) {
    function jaar(l) { var m = l.match(/(19|20)\d{2}/g); return m ? parseInt(m[m.length - 1], 10) : 0; }
    return treffers.map(function (r) {
      var score = 0;
      tokens.forEach(function (t) { if (r.codes.indexOf(t) !== -1) score += 2; else if (r.p.indexOf(' ' + t + ' ') !== -1) score += 1; });
      return { r: r, s: score, j: jaar(r.l) };
    }).sort(function (a, b) { return b.s - a.s || b.j - a.j || a.r.l.localeCompare(b.r.l); }).map(function (x) { return x.r; });
  }

  function herken(lijst, q) {
    var delen = plat(q).split(' ').filter(Boolean);
    var kt = isKenteken(q);
    var od = haalOnderdeel(delen);
    var autos = zoekAutos(lijst, od.rest);
    var onderdeelAlleen = od.onderdeel && !od.rest.length;
    var merkAlleen = null;
    if (autos.length > 3) {
      var merk = autos[0].m;
      var zelfde = autos.every(function (a) { return a.m === merk; });
      var restTekst = od.rest.map(function (d) { return MERK_ALIAS[d] || d; }).join(' ');
      if (zelfde && plat(merk) === restTekst) merkAlleen = merk;
    }
    return { delen: delen, kenteken: kt, onderdeel: od.onderdeel, autos: autos, onderdeelAlleen: onderdeelAlleen, merkAlleen: merkAlleen, rest: od.rest };
  }

  function filterUrl(auto, onderdeel) {
    return auto.u + '?' + onderdeel.types.map(function (t) { return 'filter.p.m.custom.type=' + encodeURIComponent(t); }).join('&');
  }


  function onderdeelLabel(o) { return EN && o.en ? o.en : o.label; }

  /* ---------- de autolijst, eenmalig uit de pagina ---------- */
  var cache = null;
  function lijst() {
    if (cache) return cache;
    var bron = document.querySelector('[data-dfa-autos]');
    var rijen = [];
    if (bron) { try { rijen = JSON.parse(bron.textContent) || []; } catch (e) { rijen = []; } }
    cache = bereid(rijen);
    return cache;
  }

  /* Het korte kenmerk vooraan een rij: de chassiscode uit het label, anders
     het eerste woord. "G82 / G83 M4 (2021+)" wordt G82, "Golf 7" wordt GOLF. */
  function codeVan(label) {
    var delen = String(label || '').split('(')[0].trim().split(/\s+/);
    for (var i = 0; i < delen.length; i++) {
      var d = delen[i].replace(/[^A-Za-z0-9.]/g, '');
      if (/^[A-Za-z]{1,2}\d{1,3}(\.\d)?$/.test(d) || /^\d[A-Za-z]$/.test(d) || /^(MK|Mk)\d/.test(d)) return d.toUpperCase().slice(0, 5);
    }
    return (delen[0] || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase().slice(0, 5) || '·';
  }

  function el(tag, klasse, tekst) {
    var e = document.createElement(tag);
    if (klasse) e.className = klasse;
    if (tekst != null) e.textContent = tekst;
    return e;
  }

  /* Zelfde bewaarplek als de autokiezer (df-auto.js): wie zijn auto aanklikt
     heeft hem gekozen, en de menubalk toont hem daarna als "Jouw auto". */
  function onthoud(a) {
    try { localStorage.setItem('df_auto', JSON.stringify({ merk: a.m, groep: a.g, label: a.l, url: a.u })); } catch (e) { /* laat maar */ }
  }

  /* Een kenteken uit de zoekbalk gaat naar de kentekenplaat in de autokiezer,
     die de opzoeking en de keuze tussen generaties al kent. */
  function zoekKenteken(kt) {
    var hdr = document.querySelector('.hdr');
    var paneel = document.getElementById('autokiezer');
    var tog = hdr ? hdr.querySelector('.ftog') : null;
    var vorm = paneel ? paneel.querySelector('form[data-dfa-kt]') : null;
    var veld = vorm ? vorm.querySelector('[data-dfa-kt-input]') : null;
    if (!hdr || !vorm || !veld) {
      window.location.href = '/pages/chiptuning?kenteken=' + encodeURIComponent(kt);
      return;
    }
    hdr.classList.remove('zoekopen');
    if (!hdr.classList.contains('fopen')) {
      if (tog) tog.click(); else hdr.classList.add('fopen');
    }
    veld.value = kt;
    veld.dispatchEvent(new Event('input', { bubbles: true }));
    vorm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  }

  function openKiezer() {
    var hdr = document.querySelector('.hdr');
    var tog = hdr ? hdr.querySelector('.ftog') : null;
    if (!hdr) return;
    hdr.classList.remove('zoekopen');
    if (!hdr.classList.contains('fopen')) { if (tog) tog.click(); else hdr.classList.add('fopen'); }
  }

  /* ---------- rijen voor het uitklapmenu ---------- */
  function kop(tekst, auto) {
    return el('div', 'df-zoek__kop' + (auto ? ' df-zoek__kop--auto' : ''), tekst);
  }

  function rijAuto(a, onderdeel) {
    var r = el('a', 'df-zoek__rij df-zoek__rij--auto');
    r.href = onderdeel ? filterUrl(a, onderdeel) : a.u;
    r.setAttribute('role', 'option');
    r.appendChild(el('span', 'df-zoek__code', codeVan(a.l)));
    var tx = el('div', 'df-zoek__tx');
    tx.appendChild(el('b', null, a.m + ' ' + a.l));
    tx.appendChild(el('span', null, onderdeel ? T.alleenPassend : T.alles));
    r.appendChild(tx);
    r.appendChild(el('span', 'df-zoek__pijl', '→'));
    r.addEventListener('click', function () { onthoud(a); });
    return r;
  }

  function rijMerk(merk) {
    var r = el('a', 'df-zoek__rij df-zoek__rij--auto');
    r.href = '/collections/all?filter.p.m.custom.make=' + encodeURIComponent(merk);
    r.setAttribute('role', 'option');
    r.appendChild(el('span', 'df-zoek__code df-zoek__code--merk', merk.replace(/[^A-Za-z0-9]/g, '').slice(0, 3).toUpperCase()));
    var tx = el('div', 'df-zoek__tx');
    tx.appendChild(el('b', null, T.merkAlle + merk + T.merkDelen));
    tx.appendChild(el('span', null, T.merkSub));
    r.appendChild(tx);
    r.appendChild(el('span', 'df-zoek__pijl', '→'));
    return r;
  }

  function rijKenteken(kt) {
    var net = kentekenNet(kt);
    var r = el('button', 'df-zoek__rij df-zoek__rij--auto');
    r.type = 'button';
    r.setAttribute('role', 'option');
    var plaat = el('span', 'df-zoek__plaat');
    plaat.appendChild(el('i', null, 'NL'));
    plaat.appendChild(document.createTextNode(net));
    r.appendChild(plaat);
    var tx = el('div', 'df-zoek__tx');
    tx.appendChild(el('b', null, T.zoekKt + net));
    tx.appendChild(el('span', null, T.ktSub));
    r.appendChild(tx);
    r.appendChild(el('span', 'df-zoek__pijl', '→'));
    r.addEventListener('click', function () { zoekKenteken(net); });
    return r;
  }

  /* Het autoblok voor een zoekterm, of null als er niets in zit. */
  function blok(q) {
    q = String(q || '').trim();
    if (q.length < 2) return null;
    var r = herken(lijst(), q);
    if (!r.kenteken && !r.autos.length && !r.merkAlleen) return null;
    var wrap = el('div', 'df-zoek__auto');
    wrap.setAttribute('data-df-zoek-auto', '');
    if (r.kenteken) {
      wrap.appendChild(kop(T.kenteken, true));
      wrap.appendChild(rijKenteken(r.kenteken));
    }
    if (r.merkAlleen) {
      wrap.appendChild(kop(T.jouwAuto, true));
      wrap.appendChild(rijMerk(r.merkAlleen));
    } else if (r.autos.length) {
      wrap.appendChild(kop(r.onderdeel ? onderdeelLabel(r.onderdeel) + T.voorAuto : T.jouwAuto, true));
      r.autos.slice(0, 3).forEach(function (a) { wrap.appendChild(rijAuto(a, r.onderdeel)); });
      if (r.autos.length > 3) {
        var meer = el('button', 'df-zoek__meer', (EN ? '' : 'Nog ') + (r.autos.length - 3) + T.meer);
        meer.type = 'button';
        meer.addEventListener('click', openKiezer);
        wrap.appendChild(meer);
      }
    }
    return wrap;
  }

  /* Scheiding tussen het autoblok en de producten van Shopify eronder. */
  function tussenkop() {
    var f = document.createDocumentFragment();
    var lijn = el('div', 'df-zoek__lijn'); lijn.setAttribute('data-df-zoek-tussenkop', '');
    var k = kop(T.producten, false); k.setAttribute('data-df-zoek-tussenkop', '');
    f.appendChild(lijn); f.appendChild(k);
    return f;
  }

  /* Bij elke aanslag: het autoblok meteen verversen, zonder op Shopify te
     wachten. De productrijen van de vorige vraag blijven staan tot de nieuwe
     binnen zijn; dat is het gedrag dat er al was. */
  function ververs(zoekUit, q) {
    if (!zoekUit) return;
    Array.prototype.slice.call(zoekUit.querySelectorAll('[data-df-zoek-auto],[data-df-zoek-tussenkop]')).forEach(function (n) { n.parentNode.removeChild(n); });
    var b = blok(q);
    if (!b) return;
    var niks = zoekUit.querySelector('.df-zoek__niks');
    if (niks) niks.parentNode.removeChild(niks);
    var heeftRijen = !!zoekUit.querySelector('.df-zoek__rij:not(.df-zoek__rij--auto)');
    if (heeftRijen) zoekUit.insertBefore(tussenkop(), zoekUit.firstChild);
    zoekUit.insertBefore(b, zoekUit.firstChild);
    zoekUit.hidden = false;
  }

  /* ---------- de resultatenpagina ---------- */
  function resultaten() {
    var bak = document.querySelector('[data-df-zr-auto]');
    if (!bak) return;
    var q = '';
    try { q = new URL(window.location.href).searchParams.get('q') || ''; } catch (e) { q = ''; }
    q = q.trim();
    if (q.length < 2) return;
    var r = herken(lijst(), q);
    if (!r.kenteken && !(r.autos.length && !r.merkAlleen)) return;
    while (bak.firstChild) bak.removeChild(bak.firstChild);
    bak.appendChild(el('div', 'df-zr__auto-eyebrow', r.onderdeel && r.autos.length ? onderdeelLabel(r.onderdeel) + T.voorAuto : T.zrAuto));
    if (r.kenteken) {
      var net = kentekenNet(r.kenteken);
      bak.appendChild(el('div', 'df-zr__auto-kop', T.zrKt + net));
      var strip0 = el('div', 'df-zr__auto-strip');
      var kn = el('button', 'df-zr__chip df-zr__chip--aan');
      kn.type = 'button';
      kn.appendChild(el('span', 'df-zr__code', 'NL'));
      kn.appendChild(document.createTextNode(net));
      kn.addEventListener('click', function () { zoekKenteken(net); });
      strip0.appendChild(kn);
      bak.appendChild(strip0);
      bak.appendChild(el('p', 'df-zr__auto-sub', T.ktSub));
    } else {
      var eerste = r.autos[0];
      bak.appendChild(el('div', 'df-zr__auto-kop', (r.onderdeel ? onderdeelLabel(r.onderdeel) + (EN ? ' for ' : ' voor ') : T.zrKop) + eerste.m + ' ' + eerste.l));
      var strip = el('div', 'df-zr__auto-strip');
      r.autos.slice(0, 4).forEach(function (a, i) {
        var c = el('a', 'df-zr__chip' + (i === 0 ? ' df-zr__chip--aan' : ''));
        c.href = r.onderdeel ? filterUrl(a, r.onderdeel) : a.u;
        c.appendChild(el('span', 'df-zr__code', codeVan(a.l)));
        c.appendChild(document.createTextNode(a.m + ' ' + a.l));
        c.addEventListener('click', function () { onthoud(a); });
        strip.appendChild(c);
      });
      if (r.autos.length > 4) {
        var m = el('button', 'df-zr__chip', (EN ? '' : 'Nog ') + (r.autos.length - 4) + T.meer);
        m.type = 'button';
        m.addEventListener('click', openKiezer);
        strip.appendChild(m);
      }
      bak.appendChild(strip);
      bak.appendChild(el('p', 'df-zr__auto-sub', T.zrHint));
    }
    bak.hidden = false;
  }

  window.DFZoekAuto = { blok: blok, ververs: ververs, tussenkop: tussenkop, herken: function (q) { return herken(lijst(), q); } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', resultaten); else resultaten();
})();
